import { useMsal } from '@azure/msal-react';
import { DatePicker, Dropdown, IDropdownOption, Label, PrimaryButton, Separator, Spinner, SpinnerSize, Stack, TextField, Toggle } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { japaneseStrings, listname } from '../../constants/global-values';
import { common, formatMessage } from "../../messages/common-items";
import { personalInformation } from '../../messages/personal-Information';
import { updateItem } from '../../services/graph-service';
import { fetchItemById, getTokenAndListInfo, japaneseDateConverter, phoneNumFormat, validatePhone } from '../../utils/item-helper';
import FileUpload from '../../components/file-upload';
import { BLOOD_TYPE_OPTIONS, EMERGENCY_RELATION_OPTIONS, GENDER_OPTIONS, JOBTYPE_OPTIONS, QUALIFICATION_OPTIONS } from '../../constants/options';

export default function UserEditPage() {
  const { id } = useParams();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>(null);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [siteId, setSiteId] = useState("");
  const [listId, setListId] = useState("");
  const [errors, setErrors] = useState<any>({});
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const { Labels: Lbl_Common, SuccessMessages: Success_Common, ErrorMessages: Err_Common} = common;
  const {Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info} = personalInformation;
  type phoneNumberField = "PhoneNumber" | "EmergencyPhone";
  type QualificationData = {
    file?: File | null;
    QualificationExpiry?: Date | null;
  };

  const [selectedQualificationDate, setQualificationDate] = useState<Record<string, QualificationData>>({});
  const [selectedQualification, setSelectedQualification] = useState<string[]>([]);
  const [selectedRisks, setSelectedItems] = useState<Record<string, string[]>>({});

  const [phoneNumber, setPhoneNumber] = useState<Record<phoneNumberField, string>>({
    PhoneNumber: "",
    EmergencyPhone: ""
  });
  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const { token, siteId, listId } = await getTokenAndListInfo(instance, listname);
        setSiteId(siteId);
        setListId(listId);
        setToken(token)
        const found = await fetchItemById(token, siteId, listId, id!);
        setFormData(found);
      }
      catch (error) {
        console.error("Error loading item", error);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id, instance]);
  const handleQualificationsChange = (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {
    if (!option) return;
    let updated = [...selectedOptions];
    if (option.selected) {
      updated.push(option.text);
    } else {
      updated = updated.filter(item => item !== option.text);
    }
    setSelectedOptions(updated); // update state
    handleChange("Qualifications", updated); // pass to your form handler
  };

  const validateAndSubmit = () => {

    const newErrors: any = {};
    if (!formData.Name.trim())
      newErrors.Name = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME);

    // if (!formData.DateOfBirth) {
    //   newErrors.DateOfBirth = formatMessage(Err_Common.REQUIRED_SELECT, "生年月日");
    // }
    if (!formData.Gender?.trim()) {
      newErrors.Gender = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER);
    }
    if (!formData.Address?.trim()) {
      newErrors.Address = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS);
    }
    if (!formData.PhoneNumber.trim()) {
      newErrors.PhoneNumber = formatMessage(Success_Personal_Info.PHONE_VALID);
    } else if (!(validatePhone(formData.PhoneNumber))) {
      newErrors.PhoneNumber = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!formData.EmergencyPhone?.trim()) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL);
    } else if (!validatePhone(formData.EmergencyPhone)) {
      newErrors.EmergencyPhone = formatMessage(Err_Common.INVALID_PHONE_ERR);
    }
    if (!formData.EmergencyName?.trim()) {
      newErrors.EmergencyName = formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME);
    }
    if (!formData.JobType?.trim()) {
      newErrors.JobType = formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE);
    }
    setErrors(newErrors);

    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey) {
      const el = document.getElementById(firstErrorKey);
      if (el) (el as HTMLInputElement).focus();
      return;
    }
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (key: string, value: any) => {
    setFormData({ ...formData, [key]: value ?? "" });
  };

  const handleSave = async () => {
    setLoading(true);
    await updateItem(token, siteId, listId, formData.id, formData);
    setLoading(false);
    navigate(`/shokai/koshinmsg`, { state: { from: "editshokai" } });
  };

  const handlePhoneNumberChange = (
    field: 'PhoneNumber' | 'EmergencyPhone',
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const input = event.currentTarget.value;
    const digits = input.replace(/\D/g, '').slice(0, 11);
    let formattedPhoneNum = phoneNumFormat(digits);
    setPhoneNumber(prev => ({
      ...prev,
      [field]: formattedPhoneNum,
    }));
    const numFormat = formattedPhoneNum.replace(/-/g, "");
    handleChange(field, numFormat);
  };

  if (loading || !formData)
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;

  const SectionHeader: React.FC<{ title: string }> = ({ title }) => (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
      <Label styles={{ root: { whiteSpace: "nowrap", marginLeft: 15 } }}>{title}</Label>
      <Separator styles={{ root: { flexGrow: 1 } }} />
    </Stack>
  );

  const handleQualificationChange = (_: any, option?: IDropdownOption) => {
    if (!option) return;
    const key = option.key as string;
    let selectedQualifi = [...selectedOptions];
    if (option.selected) {
      selectedQualifi.push(option.text);
    } else {
      selectedQualifi = selectedQualifi.filter(item => item !== option.text);
    }
    setSelectedOptions(selectedQualifi);
    setSelectedQualification((prev) => {
      const exists = prev.includes(key);
      const updated = exists ? prev.filter((k) => k !== key) : [...prev, key];
      if (exists) {
        const updatedItems = { ...selectedRisks };
        delete updatedItems[key];
        setSelectedItems(updatedItems);
      }
      return updated;
    });
  };

  const certificatePhotos: string[] = [
    "/images/certificate1.jpg",
    "/images/certificate2.jpg",
    "/images/certificate3.png",
    "/images/certificate4.png"
  ];
  const facePhotos: string[] = [
    "/images/avatar1.jfif",
    "/images/avatar2.jfif",
  ];
  return (
    <div className="background  list-background">
      <div className="form-container list-box">
        <div >
          <h2>{Lbl_Personal_Info.EDIT}</h2>
          <Stack tokens={{ childrenGap: 10 }}>
            <SectionHeader title={Lbl_Personal_Info.BASIC_INFO_LBL} />
            <TextField
              required
              label={Lbl_Personal_Info.NAME}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.NAME)}
              value={formData.Name}
              onChange={(_, val) => handleChange("Name", val)}
              errorMessage={errors.Name}
            />
            <DatePicker
              label={Lbl_Personal_Info.DATEOFBIRTH}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.DATEOFBIRTH)}
              strings={japaneseStrings}
              value={formData.DateOfBirth ? new Date(formData.DateOfBirth) : undefined}
              onSelectDate={(date) => {
                handleChange("DateOfBirth", date);
              }}
              formatDate={japaneseDateConverter}
            />
            <Dropdown
              required
              label={Lbl_Personal_Info.GENDER}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.GENDER)}
              selectedKey={formData.Gender}
              options={GENDER_OPTIONS}
              onChange={(_, o) => handleChange("Gender", o?.key)}
              errorMessage={errors.Gender} />
            <TextField
              required
              label={Lbl_Personal_Info.ADDRESS}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.ADDRESS)}
              value={formData.Address}
              onChange={(_, val) => handleChange("Address", val)}
              errorMessage={errors.Address} />
            <TextField
              label={Lbl_Personal_Info.PHONENUMBER}
              required
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PHONENUMBER)}
              id="PhoneNumber"
              type="tel"
              value={formData.PhoneNumber ? phoneNumFormat(formData.PhoneNumber) : ""}
              onChange={(e) => handlePhoneNumberChange("PhoneNumber", e)}
              maxLength={13}
              autoComplete="tel"
              errorMessage={errors.PHONENUMBER}
            />
            <SectionHeader title={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL} />
            <TextField
              required
              label={Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL)}
              id="EmergencyPhone"
              type="tel"
              value={formData.EmergencyPhone ? phoneNumFormat(formData.EmergencyPhone) : ""}
              onChange={(e) => handlePhoneNumberChange("EmergencyPhone", e)}
              maxLength={13}
              autoComplete="tel"
              errorMessage={errors.EMERGENCY_PHONENUMBER_LBL}
            />
            <TextField
              required
              label={Lbl_Personal_Info.EMERGENCY_NAME}
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.EMERGENCY_NAME)}
              value={formData.EmergencyName}
              onChange={(_, val) => handleChange("EmergencyName", val)}
              errorMessage={errors.EmergencyName} />
            <Dropdown
              label={Lbl_Personal_Info.EMERGENCY_RELATION}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.EMERGENCY_RELATION)}
              id="EmergencyRelation"
              options={EMERGENCY_RELATION_OPTIONS}
              onChange={(_, o) => handleChange("EmergencyRelation", o?.text)} />
            <Toggle
              label={Lbl_Personal_Info.IS_SOLE_PROPRIETOR}
              checked={formData.IsSoleProprietor === Lbl_Personal_Info.YES_OPTION}
              onChange={(_, checked) =>
                handleChange("IsSoleProprietor", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
              }/>
            <Toggle
              label={Lbl_Personal_Info.SPECIAL_LABOR_INSURANCE}
              checked={formData.SpecialLaborInsurance === Lbl_Personal_Info.YES_OPTION}
              onChange={(_, checked) =>
                handleChange("SpecialLaborInsurance", checked ? Lbl_Personal_Info.YES_OPTION : Lbl_Personal_Info.NO_OPTION)
              }/>            <TextField
              label={Lbl_Personal_Info.PARTNER_COMPANY_LBL}
              required
              placeholder={formatMessage(Err_Common.REQUIRED_VALUE, Lbl_Personal_Info.PARTNER_COMPANY_LBL)}
              id="PartnerName"
              value={formData.PartnerName}
              onChange={(_, val) => handleChange("PartnerName", val)} errorMessage={errors.PartnerName} />
            <SectionHeader title={Lbl_Personal_Info.HEALTH_INFO_LBL} />
            <Dropdown
              label={Lbl_Personal_Info.BLOOD_TYPE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.BLOOD_TYPE)}
              selectedKey={formData.BloodType}
              options={BLOOD_TYPE_OPTIONS}
              onChange={(_, o) => handleChange("BloodType", o?.key)} />
            <DatePicker
              label={Lbl_Personal_Info.HEALTH_CHECK_DATE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.HEALTH_CHECK_DATE)}
              strings={japaneseStrings}
              value={formData.HealthCheckDate ? new Date(formData.HealthCheckDate) : undefined}
              onSelectDate={(date) => {
                handleChange("HealthCheckDate", date);
              }}
              formatDate={japaneseDateConverter}/>
            <SectionHeader title={Lbl_Personal_Info.OCCUPATION_INFO_LBL} />
            <Dropdown
              required
              label={Lbl_Personal_Info.JOB_TYPE}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.JOB_TYPE)}
              selectedKey={formData.JobType}
              options={JOBTYPE_OPTIONS}
              onChange={(_, o) => handleChange("JobType", o?.key)}
              errorMessage={errors.JobType} />
            <Dropdown
              label={Lbl_Personal_Info.QUALIFICATIONS}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATIONS)}
              id="Qualifications"
              multiSelect
              selectedKeys={selectedOptions}
              options={QUALIFICATION_OPTIONS}
              onChange={handleQualificationsChange} />
            <DatePicker
              label={Lbl_Personal_Info.QUALIFICATION_EXPIRY}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATION_EXPIRY)}
              strings={japaneseStrings}
              value={formData.QualificationExpiry ? new Date(formData.QualificationExpiry) : undefined}
              onSelectDate={(date) => {
                handleChange("QualificationExpiry", date);
              }}
              formatDate={japaneseDateConverter}/>
            <Dropdown
              label={Lbl_Personal_Info.QUALIFICATIONS}
              placeholder={formatMessage(Err_Common.REQUIRED_SELECT, Lbl_Personal_Info.QUALIFICATIONS)}
              multiSelect
              options={QUALIFICATION_OPTIONS}
              selectedKeys={selectedOptions}
              onChange={handleQualificationChange}
            />
            {selectedQualification.map((taskKey) => (
              <Stack
                key={taskKey}
                tokens={{ childrenGap: 12 }}
                styles={{
                  root: {
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 20,
                  },
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {QUALIFICATION_OPTIONS.find(o => o.key === taskKey)?.text}
                </span>

                <FileUpload
                  label={Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}
                  placeholder={Success_Personal_Info.NO_IMAGE_SELECTED}
                  multiple={false}
                  onFileSelect={(files) => {
                    const file = files[0] || null;
                    setQualificationDate((prev) => ({
                      ...prev,
                      [taskKey]: { ...prev[taskKey], file },
                    }));
                  }}
                />
                <DatePicker
                  label={Lbl_Personal_Info.QUALIFICATION_EXPIRY}
                  placeholder={formatMessage(
                    Err_Common.REQUIRED_SELECT,
                    Lbl_Personal_Info.QUALIFICATION_EXPIRY
                  )}
                  strings={japaneseStrings}
                  value={selectedQualificationDate[taskKey]?.QualificationExpiry || undefined}
                  onSelectDate={(date) => {
                    const selDate = date || null;
                    setQualificationDate((prev) => ({
                      ...prev,
                      [taskKey]: { ...prev[taskKey], QualificationExpiry: selDate },
                    }));
                    handleChange("QualificationExpiry", date);
                  }}
                  formatDate={japaneseDateConverter}
                />
              </Stack>
            ))}
            {/* <FileUpload
              label={Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}
              placeholder={Success_Personal_Info.NO_IMAGE_SELECTED} /> */}
            <FileUpload
              label={Lbl_Personal_Info.FACE_PHOTOS_LBL}
              placeholder={Success_Personal_Info.NO_IMAGE_SELECTED} />
            <Stack horizontal className="buttonallign" tokens={{ childrenGap: 10 }}>
              <PrimaryButton className="custom-primary-button" text={Lbl_Common.SAVE} onClick={() => {
                if (validateAndSubmit()) {
                  setLoading(true);
                  handleSave();
                }
              }} />
              <PrimaryButton className="cancel-button" text={Lbl_Common.CANCEL} onClick={() => navigate(-1)} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
}